import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getUopList = (params) => {
    return AxiosService.Get(`api/cam/pc/unit-operation-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

 

  getMetaList = () => {
    return AxiosService.Get(`api/cam/pc/dropdown-all/`, {
      ...this.getHeaders(),
      // params: params,
    });
  };

  addUop = (data, obj) => {
    return AxiosService.Post(`api/cam/pc/create-new-unit-operation/`, data, {
      // params: data,
      ...this.getHeaders(),
    });
  };
  
  deleteUop = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-unit-operation/`, obj);
  };

  approveUop = (obj) => {
    return AxiosService.Post(`api/cam/pc/approve-unit-operation/`, obj);
  };

  updateUop = ( obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-unit-operation/`,
      obj,
      // params,
      true,
      this.getHeaders()
    );
  };
}
